"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _unescapedText = _interopRequireDefault(require("I18n/utils/unescapedText"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _FormattedJSXMessage = _interopRequireDefault(require("I18n/components/FormattedJSXMessage"));

var _UIErrorMessage = _interopRequireDefault(require("UIComponents/error/UIErrorMessage"));

var _UILink = _interopRequireDefault(require("UIComponents/link/UILink"));

var _urls = require("../../utils/urls");

var GenericError = function GenericError() {
  var _useLocation = (0, _reactRouterDom.useLocation)(),
      pathname = _useLocation.pathname;

  return _react.default.createElement(_UIErrorMessage.default, {
    title: (0, _unescapedText.default)('appMarketplace.error.default.title')
  }, _react.default.createElement("p", null, _react.default.createElement(_FormattedMessage.default, {
    message: "appMarketplace.error.default.body"
  })), _react.default.createElement("p", null, _react.default.createElement(_FormattedJSXMessage.default, {
    message: "appMarketplace.error.default.cta_jsx",
    options: {
      onRefresh: function onRefresh() {
        return window.location.reload();
      },
      loginUrl: (0, _urls.getLoginUrlWithRedirect)(pathname)
    },
    elements: {
      Link: _UILink.default
    }
  })));
};

var _default = GenericError;
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/components/error/GenericError.js
// module id = 271
// module chunks = 209 210 211 212